import {observer} from "mobx-react";
import {DialogStore, fmsPackageDetailStore, growlStore} from "../../../store";
import {FieldSelect, ModalDialog} from "../../ui";
import {ShipmentTypeDto} from "../../../api/fms";
import {displayShipmentType} from "../../../api";
import {useState} from "react";

interface FmsModalDialogShipmentTypeProps {
    store: DialogStore
}

const shipmentOptions = Object.keys(ShipmentTypeDto)
    .map(e => e as ShipmentTypeDto)
    .filter(e => e !== ShipmentTypeDto.POST)
    .map(e => ({
        value: e,
        label: displayShipmentType(e as ShipmentTypeDto)
    }))

const FmsModalDialogShipmentType = observer(function FmsModalDialogShipmentType({
                                                                                    store
                                                                                }: FmsModalDialogShipmentTypeProps) {
    const [shipmentType, setShipmentType] = useState(fmsPackageDetailStore.data?.shipmentType || ShipmentTypeDto.POST)
    return <ModalDialog
        store={store}
        actions={[
            {
                label: "Abbrechen",
                execute: async function () {

                    store.dialogOpen = false
                },
                className: 'is-primary is-rounded is-small'
            },
            {
                label: "Versandart ändern",
                execute: async function () {
                    store.executing = true

                    const success = await fmsPackageDetailStore.patchShipmentType(shipmentType)
                    if (success) {
                        growlStore.add({
                            message: 'Versandart erfolgreich aktualisiert',
                            autoclose: true,
                            closable: true
                        })
                    }

                    store.executing = false
                    store.dialogOpen = !success
                },
                className: 'is-rounded is-small'
            }
        ]}
        title={"Versandart ändern"}
    >
        <FieldSelect
            label={'Versandart'}
            options={shipmentOptions}
            value={shipmentType}
            onChange={e => {
                setShipmentType(e as ShipmentTypeDto)
            }}
        />
    </ModalDialog>
})

export {
    FmsModalDialogShipmentType
}
